// Shared status label/badge maps, mirroring BroadcastTable.component.jsx.

export const CAMPAIGN_STATUS_LABEL = {
  ERROR: "Error",
  FINISHED: "Finalizada",
  IN_PROGRESS: "En progreso",
  SCHEDULED: "Programada",
  PAUSED: "Pausada",
  WAITING_FOR_APPROVAL_TEMPLATE: "En espera de aprobación de plantilla",
  CANCELED: "Cancelada",
};

export const CAMPAIGN_STATUS_VARIANT = {
  ERROR: "error",
  FINISHED: "done",
  IN_PROGRESS: "progress",
  SCHEDULED: "pending",
  PAUSED: "pending",
  WAITING_FOR_APPROVAL_TEMPLATE: "pending",
  CANCELED: "error",
};
